import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id B74F1DE6-5DEC-4866-AEED-DE85FE09C52F
 * name factory
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/factory.svg
 * tags
 * - Places 
 * - Hardware / Tools 
 */
export const FactoryIcon = createSvgIcon(<><path d="M4,18V20H8V18H4M4,14V16H14V14H4M10,18V20H14V18H10M16,14V16H20V14H16M16,18V20H20V18H16M2,22V8L7,12V8L12,12V8L17,12L18,2H21L22,12V22H2Z" /></>, 'FactoryIcon');
export default FactoryIcon